export default __webpack_public_path__ + "static/media/Candara_Italic.ea54cb03.ttf";